export interface ModalOneConfig {
 visible?: boolean;
  modalTitle?: string;
  modalTitleDescription?: string;
  founderImage?: string;
  ariaLabelledBy?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl' | 'xxl';
}

export const DEFAULT_MODALONE_CONFIG: ModalOneConfig = {
  visible: false,
  modalTitle: '',
  modalTitleDescription: '',
  founderImage: '',
  ariaLabelledBy: 'staticBackdropLabel',
  size: 'md',
}